import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
export type OsintLocationFragment = {
  __typename: 'OSINTLocation'
  locationId?: string | null
  approximateDate?: string | null
  rating?: number | null
  comment?: string | null
  name?: string | null
  cost?: number | null
  address?: string | null
  tags: Array<string>
  position: { __typename: 'OSINTPosition'; latitude: number; longitude: number }
  guidedAnswers: Array<{
    __typename: 'OSINTLocationGuidedAnswer'
    id: string
    question: string
    answer: string
  }>
}

export type OsintNodeListViewMetadataFragment = {
  __typename: 'OSINTNodeListViewMetadata'
  nodeId: string
  searchInput: string
  searchInputType: Types.OsintSearchInputType
  isCached: boolean
  updatedSearchInput: string
  searchedOn: string
  nodeGroups: Array<{
    __typename: 'OSINTNodeGroup'
    groupId: string
    name: string
  }>
  photos: Array<{
    __typename: 'OSINTPhoto'
    imageUrl: string
    description: string
    nodeId: string
  }>
  mapInfo: Array<{
    __typename: 'OSINTLocation'
    locationId?: string | null
    approximateDate?: string | null
    rating?: number | null
    comment?: string | null
    name?: string | null
    cost?: number | null
    address?: string | null
    tags: Array<string>
    position: {
      __typename: 'OSINTPosition'
      latitude: number
      longitude: number
    }
    guidedAnswers: Array<{
      __typename: 'OSINTLocationGuidedAnswer'
      id: string
      question: string
      answer: string
    }>
  }>
}

export type NodeMetaDataFragment = {
  __typename: 'NodeMetaData'
  isSearchable: boolean
  isCopyable: boolean
  nodeId?: string | null
  isBookmarked: boolean
  searchInputType?: Types.OsintSearchInputType | null
}

export type OsintNodeFragment = {
  __typename: 'OSINTNode'
  nodeId: string
  nodeName: string
  logoUrl?: string | null
  nodeUrl: string
  nodeType: Types.OsintNodeType
  nodeMetaData: {
    __typename: 'NodeMetaData'
    isSearchable: boolean
    isCopyable: boolean
    nodeId?: string | null
    isBookmarked: boolean
    searchInputType?: Types.OsintSearchInputType | null
  }
}

export type OsintNodeGroupDetailsFragment = {
  __typename: 'OSINTNodeGroupDetails'
  groupId: string
  name: string
  totalNodesCount: number
  nodes: Array<{
    __typename: 'OSINTNode'
    nodeId: string
    nodeName: string
    logoUrl?: string | null
    nodeUrl: string
    nodeType: Types.OsintNodeType
    nodeMetaData: {
      __typename: 'NodeMetaData'
      isSearchable: boolean
      isCopyable: boolean
      nodeId?: string | null
      isBookmarked: boolean
      searchInputType?: Types.OsintSearchInputType | null
    }
  }>
}

export type OsintNodePropertyFragment = {
  __typename: 'OSINTNodeProperty'
  key: string
  value: string
  isSearchable: boolean
  isCopyable: boolean
  nodeId?: string | null
  searchInputType?: Types.OsintSearchInputType | null
}

export type OsintGroupFragment = {
  __typename: 'OSINTGroup'
  groupId: string
  groupName: string
  newItemsCount: number
  totalItemsCount: number
}

export type OsintHandleItemFragment = {
  __typename: 'OSINTHandleItem'
  nodeId?: string | null
  searchItemId: number
  createdAt: string
  searchInput: string
  searchInputType: Types.OsintSearchInputType
  status: Types.OsintStatus
  handleId: string
}

export const OsintLocationFragmentDoc = gql`
  fragment OSINTLocation on OSINTLocation {
    locationId
    approximateDate
    rating
    comment
    name
    cost
    address
    tags
    position {
      latitude
      longitude
    }
    guidedAnswers {
      id
      question
      answer
    }
  }
`
export const OsintNodeListViewMetadataFragmentDoc = gql`
  fragment OSINTNodeListViewMetadata on OSINTNodeListViewMetadata {
    nodeId
    searchInput
    searchInputType
    isCached
    updatedSearchInput
    searchedOn
    nodeGroups {
      groupId
      name
    }
    photos {
      imageUrl
      description
      nodeId
    }
    mapInfo {
      ...OSINTLocation
    }
  }
  ${OsintLocationFragmentDoc}
`
export const NodeMetaDataFragmentDoc = gql`
  fragment NodeMetaData on NodeMetaData {
    isSearchable
    isCopyable
    nodeId
    isBookmarked
    searchInputType
  }
`
export const OsintNodeFragmentDoc = gql`
  fragment OSINTNode on OSINTNode {
    nodeId
    nodeName
    logoUrl
    nodeUrl
    nodeType
    nodeMetaData {
      ...NodeMetaData
    }
  }
  ${NodeMetaDataFragmentDoc}
`
export const OsintNodeGroupDetailsFragmentDoc = gql`
  fragment OSINTNodeGroupDetails on OSINTNodeGroupDetails {
    groupId
    name
    totalNodesCount
    nodes {
      ...OSINTNode
    }
  }
  ${OsintNodeFragmentDoc}
`
export const OsintNodePropertyFragmentDoc = gql`
  fragment OSINTNodeProperty on OSINTNodeProperty {
    key
    value
    isSearchable
    isCopyable
    nodeId
    searchInputType
  }
`
export const OsintGroupFragmentDoc = gql`
  fragment OSINTGroup on OSINTGroup {
    groupId
    groupName
    newItemsCount
    totalItemsCount
  }
`
export const OsintHandleItemFragmentDoc = gql`
  fragment OSINTHandleItem on OSINTHandleItem {
    nodeId
    searchItemId
    createdAt
    searchInput
    searchInputType
    status
    handleId
  }
`
